<div
  class="b-boolean-icon"
  [ngClass]="class"
  (click)="onValueChange($event)"
></div>
